import { object, string, InferType } from 'yup'

const schema = object({
  dispatcherName: string().max(50, 'fieldMaxLength').required('requiredField').default(''),
  dispatcherSignature: string().required().default('')
})

export type Dispatcher = InferType<typeof schema>

export default schema
